import { ChangeEventHandler, useState } from "react";

export function useInput(defaultValue = "") {
  const [value, setValue] = useState(defaultValue);

  const onChange: ChangeEventHandler<HTMLInputElement> = ({ target: { value } }) => {
    setValue(value);
  };

  return { value, onChange };
}
